import styled from 'styled-components'

export const Outer = styled.section`
  display: flex;
  justify-content: center;
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1025px;
  height: 100%;
  min-height: 605px;
  box-shadow: 0 6px 20px 3px rgba(0, 0, 0, 0.5);
  background-color: #000000;
  opacity: 0.88;
  margin: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  text-align: center;
  overflow: hidden;
  position: relative;
  padding-bottom: 106px;
  @media only screen and (max-width: 660px) {
    margin: 2rem 1rem 4rem;
    min-height: 500px;
  }
`
export const Text = styled.div`
  padding: 3rem 2rem;
  @media only screen and (max-width: 660px) {
    > h1 {
      font-size: 24px !important;
    }
    > h2 {
      font-size: 20px !important;
    }
  }
  > h1 {
    font-size: 30px;
    font-weight: 400;
    max-width: 763px;
    line-height: 1.4;
    margin-bottom: 1.6rem;
  }
  > h2 {
    font-size: 25px;
    font-weight: 400;
    margin-bottom: 5rem;
  }
  .bottom {
    > p {
      margin-bottom: 0.4rem;
      font-size: 18px;
    }
  }
`

export const Graphic = styled.div`
  padding-bottom: 4rem;
  padding-top: 4rem;
  @media only screen and (max-width: 660px) {
    padding-bottom: 2rem;
  }
`

export const Controller = styled.div`
  display: flex;
  width: 100%;
  .active {
    transform: translateY(-8px);
  }
  position: absolute;
  bottom: 0;
`

export const Control = styled.div`
  background-color: #ecedef;
  flex: 1;
  z-index: 10;
  position: relative;
  color: black;
  padding: 0 1rem;
  transition: transform ease-in 200ms;
  height: 105px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:nth-child(2) {
    margin: 0 1px;
  }

  &:after {
    bottom: -8px;
    position: absolute;
    background-color: #00a1ff;
    width: 100%;
    height: 8px;
    content: '';
  }
  > div {
    width: 100%;
  }
  &:first-child {
    > div {
      max-width: 157px;
    }
  }
  &:nth-child(2) {
    > div {
      max-width: 249px;
    }
  }
  &:last-child {
    > div {
      max-width: 220px;
    }
  }
`
